export const isRiskSettingVisibleInOverview = (riskSetting) => {
  if (!riskSetting) {
    return false;
  }

  // Hide Re-Enable for all accounts.
  if (riskSetting.name === "re_enable") {
    return false;
  }

  // Hide overnight exposure when backend marks it as disabled.
  if (
    riskSetting.name === "allowed_overnight_exposure" &&
    riskSetting.settings?.disabled === true
  ) {
    return false;
  }

  return true;
};

export const getVisibleRiskSettingsMetadata = (riskSettingMetadata = []) =>
  (riskSettingMetadata || []).filter(isRiskSettingVisibleInOverview);
